/**
 * direct_list / edit_ajax 等接口里，第三方账户的 otherBroker 有时是对象，
 * 有时是 JSON 字符串（如 '{"brokerName":"123123"}'），甚至多次 stringify。
 *
 * @param {unknown} raw
 * @returns {Record<string, unknown>|null} 解析后的对象；无法解析则 null
 */
export function normalizeOtherBroker(raw) {
  if (raw == null || raw === "") {
    return null;
  }
  let cur = raw;
  for (let d = 0; d < 3 && typeof cur === "string"; d++) {
    const t = String(cur).trim();
    if (!t) {
      return null;
    }
    try {
      cur = JSON.parse(t);
    } catch (e) {
      return null;
    }
  }
  if (!cur || typeof cur !== "object" || Array.isArray(cur)) {
    return null;
  }
  return cur;
}



// WEBPACK FOOTER //
// ./src/view/user/eval_jees/third_party/otherBroker.js